



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { Member } from '../../models/member.model';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user.model';
import { Subject } from 'rxjs';
import { MemberAccess } from '../../models/member-access.model';
import { MemberAccessActionType } from '../../models/enums';

@Component({
    selector: 'history',
    template: require('./history.component.html'),
    styles: [require('./history.component.css')],
    animations: [fadeInOut]
})
export class HistoryComponent {
    searchText: string;
    isGettingMembers = false;
    memberDetailsParams: any = {};
    history: Member[] = [];
    currentUser: User;
    isSearching = false;
    memberAccessesPagedResult= {
        results: [],
        rowCount: 0,
        currentPage: 0,
        pageSize: 10
    };
    totalHistory: any;
    //page = {
    //    pageNumber: 1,
    //    size: 10,
    //}

    private subject: Subject<string> = new Subject();

    constructor(private router: Router, private apiService: ApiService, private authService: AuthService,
        private activateRouter: ActivatedRoute,
        public dialog: MatDialog, private alertService: AlertService) {
        //this.getTotalHistory()
        this.currentUser = this.authService.currentUser;
        var memberId = activateRouter.snapshot.queryParams.memberid;
        if (memberId) {
            this.getByMemberId(memberId, this.memberAccessesPagedResult.currentPage + 1, this.memberAccessesPagedResult.pageSize);
        } else {
            this.getPagedResult(this.memberAccessesPagedResult.currentPage +1, this.memberAccessesPagedResult.pageSize);
        }

    }

    getTotalHistory() {
        this.apiService.getAllMemberAccessLastRecords().subscribe(r => {
            this.totalHistory = r.length;
            console.log(this.totalHistory)
        })
    }

    onRefresh() {
        this.memberAccessesPagedResult.results = [];
        this.memberAccessesPagedResult.currentPage = 0;
        this.getPagedResult(this.memberAccessesPagedResult.currentPage + 1, this.memberAccessesPagedResult.pageSize);
    }

    getChangePage(page) {
       // this.page.pageNumber = page.offset
        //console.log(this.page)
        this.memberAccessesPagedResult.results = [];
        this.getPagedResult(page.offset + 1, this.memberAccessesPagedResult.pageSize);
    }


    getPagedResult(skip, take) {
        this.apiService.getMemberAccessPagination(skip, take).subscribe(r => {
            this.memberAccessesPagedResult = r;
            this.memberAccessesPagedResult.currentPage--;
        })
    }

    getByMemberId(memberId, skip, take) {
        this.apiService.getMemberAccessByMemberId(memberId, skip, take).subscribe(r => {
            this.memberAccessesPagedResult = r;
            this.memberAccessesPagedResult.currentPage--;
        })
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/history/history.component.ts